module.exports = __webpack_public_path__ + "static/team2-278e723ee28de8bd696c070393276f30.jpg";